import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {OverviewListColoredYarnSetWithStartDent} from '@domain/textile-data/creel/overview-list-colored-yarn-set-with-start-dent';
import {convertCommercialUnit, convertDentsToWidthInMeter, Unit} from '@vdw/angular-component-library';
import {map} from 'lodash-es';

export function getColoredYarnSetPaths(productionSchedulePathsOfColoredYarnSets: ProductionSchedulePathsOfColoredYarnSet[], reedDensityInDentsPerMeter: number): any {
  return map(productionSchedulePathsOfColoredYarnSets, (productionSchedulePathsOfColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet) => {
    const coloredYarnSet: OverviewListColoredYarnSetWithStartDent = productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet;
    const result: any = productionSchedulePathsOfColoredYarnSet.toJSON();

    result.technicalWidthInDents = coloredYarnSet.technicalWidthInDents;
    result.commercialWidthInMM = convertCommercialUnit({
      from: {unit: Unit.METER, value: convertDentsToWidthInMeter(coloredYarnSet.technicalWidthInDents, reedDensityInDentsPerMeter)},
      to: Unit.MILLIMETER
    });

    return result;
  });
}
